import { ApplicationWithCmsState } from '../../store/types';

export const getPrismicReferenceRequestStateSelector = (
  state: ApplicationWithCmsState,
) => state.cms.prismicReference.requests.getPrismicReference;

export const prismicReferenceSelector = (state: ApplicationWithCmsState) => ({
  prismicReference: state.cms.prismicReference?.prismicReference,
});
